<template>
	<div class="mPeggy-box">
		<div class="HelpcenterBox">
			<div class="HelpcenterBox-li">
				<div style="width: 1270px; margin: auto; padding: 0">
					<div class="HelpcenterBox-center">
						<div class="left">
							<router-link to="/">
								<img :src="require('@/assets/user-logo.png')" alt=""
							/></router-link>
						</div>

						<!-- <router-link to="/parts-list"> -->
						<div class="right">
							<el-input style="border: 0px" v-model="searchKey"></el-input>
							<el-button
								style="height: 40.5px; border-radius: 0; margin-top: 30px"
								@click="handelSearch()"
								>搜索</el-button
							>
						</div>
						<!-- </router-link> -->
						<div class="gouWu">
							<router-link to="/cart">
								<img src="@/assets/gouwu.png" alt="" />
								我的购物车
								<i class="el-icon-arrow-right"></i>
								
							</router-link>

		                   <span class="totle">{{cartNum}}</span>
							
						</div>
						
					</div>
				</div>
			</div>
		</div>

		<router-view name="main" />
	</div>
</template>
<script>
// import user from "./user/index.vue";
// import OrderList from "@/views/merchant/order/list/index";
import {mapState} from "vuex"

export default {
	inheritAttrs: false,
	name: "Mine",
	props: {
		className: String
	},
	// created(){
	//   let test=this.className
	//   debugger
	// },
	//   components: {
	// 	user,
	// 	OrderList
	//   },
	//   computed: {
	//     currentTabComponent() {
	// 		console.log(this.$route.fullPath.includes('/order/list'))
	// 		if(this.className=='PQ') return 'user'
	// 		else if(this.className=='DD'||this.$route.fullPath.includes('/order/list')) return 'order-list'
	// 	},
	//   },
	// watch: {
	//   $route: {
	//     handler(to, from) {
	//       if (to.fullPath.includes("/mine")) this.className = "PQ";
	//       else if (to.fullPath.includes("/order/list")) this.className = "DD";
	//     },
	//     immediate: true,
	//   },

	//   // $route(to, from) {
	//   // 	debugger
	//   //   if (to.fullPath.includes("/order/list")) {
	//   // 	  debugger
	//   //   }this.className == "DD";
	//   // },
	// },
	data() {
		return {
			//     tabPosition: "left",
			//     // className: "",
			valueName: "",
			searchKey: ""
			//     ChildpagesName: "Accessoriestoretrieve",
		}
	},
	//   created() {
	//     console.log(this.$route);
	//   },
	computed: {
		...mapState({
			
			cartNum: (state) => state.merchant.cartNum,
			
		})
	},
	methods: {
		// clickPQ() {
		//   // 我的配琪
		//   this.className = "PQ";
		// },
		// clickDD() {
		//   // 我的订单
		//   this.className = "DD";
		// },
		// clickXX() {
		//   // 消息
		//   this.className = "XX";
		// },
		// clickLi(list) {
		//   this.ChildpagesName = list;
		// },
		handelSearch() {
			this.$router.push({
				name: "parts-list",
				params: {
					searchType: "名称",
					searchKey: this.searchKey
				}
			})
		}
	}
}
</script>

<style lang="scss">
.mPeggy-box {
	position: relative;
			// justify-content: space-between;
			
	border-bottom: 2px solid #1d2089;

	// min-height:700px;
	.user-title {
		opacity: 1;
		background: rgba(29, 32, 137, 1);

		.conter {
			width: 1900px;
		}
	}
}

.HelpcenterBox {
	// margin-bottom: 50px;
	li {
		list-style: none;
	}

	.active {
		color: red;
	}

	.box {
		width: 100%;
	}

	background-color: #f3f4f6;

	.HelpcenterBox-li {
		// display: flex;
		height: 100px;
		background-color: #1d2089;
		// line-height: 100px;

		.HelpcenterBox-center {
			display: flex;
			position: relative;
			.totle{
				position: absolute;
				right:125px;
				top: 3px;
				box-sizing: border-box;
				min-width: 16px;
				height: 16px;
				padding: 0 4px;
				border-radius: 50px;
				color: #fff;
				background: #ff4f1a;
				font-size: 12px;
				line-height: 15px;
				text-align: center;
				cursor: pointer;
			}
			.left {
				color: rgb(4, 4, 4);
				line-height: 100px;
				flex: 1;
				cursor: pointer;
				img {
					margin-top: 22px;
					width: 170px;
					height: 58px;
				}

				// margin-left: 30px;
			}

			.right {
				display: flex;
				float: right;

				.el-input.el-input--small {
					width: 250px;
				}

				button.el-button.el-button--default.el-button--small {
					margin-top: 25px;
					border: 0;
					width: 78px;
					color: #fff;
					background: linear-gradient(
						90deg,
						rgba(37, 117, 252, 1) 0%,
						rgba(106, 17, 203, 1) 100%
					);
					font-size: 18px;
					// margin-right: 20px;
				}

				input.el-input__inner {
					width: 252px;
					border-radius: 0;
					border: 0;
					margin-top: 30px;
				}

				input {
					height: 40.5px;
				}
			}

			.gouWu {
				position: relative;
				padding: 0 5px 0 0;
				text-align: center;
				// width: 185px;
				margin-top: 30px;
				margin-left: 10px;
				height: 40px;
				line-height: 40px;
				opacity: 1;
				background: rgba(255, 255, 255, 1);
				font-size: 18px;
				color: rgba(56, 56, 56, 1);
				cursor: pointer;
				img {
					width: 21px;
					margin-top: 10px;
					margin-left: 15px;
				}

				i {
					color: rgba(254, 118, 72, 1);
					cursor: pointer;
					font-weight: 600;
				}
				span{
					color: #fff;
					position: absolute;
					// width: 50px;
					background-color: #fe7648;
					border-radius: 50%;
					padding: -1px ;
				}
			}
		}
	}
}
</style>
